/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Next_Event_TooltipInputs */



/**
* | output |
* | --- |
* | "The next event to be shown on screen" |
*
* @param {Timing_Sync_Next_Event_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_next_event_tooltip = /** @type {((inputs?: Timing_Sync_Next_Event_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Next_Event_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le prochain evenement a afficher a l'ecran")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das nächste Ereignis, das auf dem Bildschirm angezeigt wird")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il prossimo evento da mostrare sullo schermo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Следующее событие будет показано на экране.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El próximo evento que se mostrará en pantalla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("屏幕上即将显示的下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画面に表示される次のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रीन पर दिखाई जाने वाली अगली घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O próximo evento a ser exibido na tela")
	return /** @type {LocalizedString} */ ("The next event to be shown on screen")
});